<template>
  <div
    :style="`background-color: ${
      loading ? 'white' : 'whitesmoke'
    }; height: 100%`"
  >
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <div v-else>
      <v-container class="Kanit px-5 pb-1" grid-list-xs>
        <div style="text-align: center" class="py-2 mb-3">
          <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
        </div>
        <div class="text-center">
          <h3 style="color: #0c4d9d; font-style: italic" class="mb-0">
            กรุณา
            <span
              style="
                color: rgb(238 151 20);
                font-size: 1.5em;
                margin-right: 2.6px;
              "
              >คลิกเลือก</span
            >ช่างทาสีที่คุณต้องการ
          </h3>
        </div>
      </v-container>
      <div
        class="center Kanit"
        style="
          font-weight: 200;
          color: white;
          background-color: #0c4d9d;
          height: 3.5em;
        "
      >
        ท่านสามารถเลือกช่างทาสี
        <span
          style="
            font-weight: 600;
            font-size: 1.2em;
            font-style: italic;
            color: rgb(255 221 227);
          "
          >ได้มากกว่าหนึ่งท่าน</span
        >
      </div>
      <div class="pa-2 pt-3 Kanit" style="padding-bottom: 80px">
        <v-card
          @click="clickSelect(painter)"
          v-for="(painter, index) in painters"
          :key="painter.id"
          outlined
          class="pa-1 px-4 mb-2"
          style="border-radius: 10px"
        >
          <div>
            <v-row row wrap>
              <v-col cols="4" class="px-0 py-1">
                <v-row style="height: 100%" no-gutters>
                  <v-col class="center" cols="5">
                    <span
                      style="font-weight: 600; color: #0c4d9d; font-size: 17px"
                      >#{{ index + 1 }}</span
                    >
                  </v-col>
                  <v-col cols="7" class="center">
                    <div v-if="painter.profile_pic">
                      <v-img
                        lazy-src="../assets/whiteimg.jpg"
                        style="border-radius: 10px"
                        @error="() => (painter.profile_pic = null)"
                        height="72px"
                        width="67px"
                        :src="painter.profile_pic"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>
                    <div v-else>
                      <div
                        style="
                          height: 100px;
                          width: 100px;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        <v-icon>mdi-block-helper</v-icon>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="px-0 pl-2 py-1">
                <div style="position: relative">
                  <div style="font-weight: 900; font-size: 1em">
                    {{ painter.painter_name }}
                  </div>
                  <div style="position: absolute; bottom: -16px">
                    <star-rating
                      :inline="true"
                      :rating="
                        painter.painter_average_review
                          ? parseFloat(painter.painter_average_review)
                          : 0
                      "
                      :read-only="true"
                      :rounded-corners="true"
                      :star-size="14"
                      :increment="0.1"
                    ></star-rating>
                    <span class="ml-1" style="font-size: 12px"
                      >({{
                        painter.painter_customer_review
                          ? painter.painter_customer_review
                          : 0
                      }})</span
                    >
                  </div>
                </div>
                <div
                  style="font-size: 10px; line-height: 13px; margin-top: 18px"
                >
                  {{
                    painter.painter_experience
                      ? painter.painter_experience.join(", ")
                      : "-"
                  }}
                </div>
              </v-col>
              <v-col class="py-1 pa-0 center" cols="2">
                <v-icon
                  v-if="selected.includes(painter.id)"
                  style="font-size: 45px; color: yellowgreen"
                  >mdi-check</v-icon
                >
              </v-col>
            </v-row>
          </div>
        </v-card>
      </div>
      <div @click="confirmData" v-ripple class="addcartbtn Kanit myshadow">
        <p v-if="!saveloading">ยืนยันข้อมูล</p>
        <div v-else>
          <v-progress-circular
            indeterminate
            size="35"
            color="white"
          ></v-progress-circular>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import StarRating from "vue-star-rating";
import Loading from "@/components/Loading.vue";
export default {
  components: {
    Loading,
    StarRating,
  },
  data() {
    return {
      saveloading: false,
      loading: true,
      selected: [],
      painters: [],
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getPainter();
    this.loading = false;
  },
  methods: {
    confirmData() {
      if (!this.saveloading) {
        if (this.selected.length) {
          this.saveloading = true;
          var data = {
            userid: this.$store.state.userid,
            apptype: this.query.apptype,
            pageid: this.query.pageid,
            orderid: this.$store.state.orderid, // มาจาก resp หน้ากรอกข้อมูลหาช่างของ customer
            painterlistid: this.selected, // Array userid ของช่างที่เลือก
          };
          axios
            .post(
              "https://communitybotbyzwizai.herokuapp.com/toasendjobtopainters",
              data,
              {
                headers: { AUTHORIZATION: "Bearer xxx xxx" },
              }
            )
            .then(async (response) => {
              this.saveloading = false;
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              } else if (response.data.responsecode == 200) {
                await this.$swal.fire({
                  text: "สำเร็จ",
                  icon: "success",
                });
                if (this.query.apptype == "line") {
                  await this.$liff.closeWindow();
                } else if (this.query.apptype == "facebook") {
                  this.$store.dispatch("messengerClose");
                }
              }
            });
        } else {
          this.$swal.fire({
            text: "กรุณาเลือกช่างทาสีอย่างน้อย 1 คน",
          });
        }
      }
    },
    getPainter() {
      return new Promise((resolve) => {
        axios
          .get("https://communitybotbyzwizai.herokuapp.com/toasearchpainter", {
            params: {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: this.query.pageid,
            },
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            this.loading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              this.painters = response.data.data;
            }
            resolve();
          });
      });
    },
    clickSelect(item) {
      if (this.selected.includes(item.id)) {
        this.selected.splice(
          this.selected.findIndex((el) => el == item.id),
          1
        );
      } else {
        this.selected.push(item.id);
      }
    },
  },
};
</script>

<style lang="scss">
.vue-star-rating-rating-text {
  margin: 0px !important;
  margin-left: 6px !important;
  font-size: 12px !important;
  margin-top: 4px !important;
}
</style>